module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiYAAAImAgMAAAAaoKnVAAAACVBMVEXYHgXlbFv///8RTLiTAAABJElEQVR42u3OsQ3AIAwAQWdDGvajoGLKTOCkQLGEcr/AX4QkSZIkSZIkSZIkSZIkSZIkSZK26nmtmLLyBgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgrKwZRrfddEQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFB+Q3ltYfViNpQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUErreS0kSZIkSZIkSZIkSZIkSZIkSZK01Q10LOFNyKn2YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flag/ch.png
// module id = ZXpz
// module chunks = 0